import { render } from "./VehicleModal.vue?vue&type=template&id=46ad1c90&ts=true"
import script from "./VehicleModal.vue?vue&type=script&lang=ts"
export * from "./VehicleModal.vue?vue&type=script&lang=ts"

import "./VehicleModal.vue?vue&type=style&index=0&id=46ad1c90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__